<template>
  <div class="col-10 mb-4">
    <h4>Banners</h4>
    <div class="card card-body mb-2">
      <div class="indeterminate-progress-bar mb-2" v-show="loading.slides">
        <div class="indeterminate-progress-bar__progress"></div>
      </div>
      <div class="d-flex" style="overflow: auto">
        <img
          :class="['slide-img-presentation', selIndex == index ? 'selected' : '']"
          :src="slide.PathUrl"
          alt="Slide"
          v-for="(slide, index) in slides"
          :key="slide.id + slide.photo_id + index"
          @click="selectSlide(index)"
        />
      </div>
    </div>
    <div class="slides_form" v-if="selIndex != null">
      <div class="card card-body mb-4">
        <div class="d-flex justify-content-between">
          <h4>Editar banner</h4>
          <div>
            <button class="btn btn-outline-light" @click="eliminarBanner(selIndex)">
              <i class="fal fa-trash-alt"></i> Eliminar
            </button>
            <button class="btn btn-outline-light ms-2" @click="closeSelectSlide">
              <i class="fal fa-times"></i> Cerrar
            </button>
          </div>
        </div>
        <div class="d-flex">
          <img :src="slides[selIndex].PathUrl" alt="Slide" style="width: 60%; border-radius: 5px" />
          <div class="ms-3 row">
            <div class="form-group">
              Titulo: <input type="text" class="form-control" v-model="slides[selIndex].title" />
            </div>
            <div class="form-group">
              Titulo (Ingles): <input type="text" class="form-control" v-model="slides[selIndex].en_title" />
            </div>
            <div class="form-group col-lg-8">
              Tipo:
              <select
                v-model="slides[selIndex].type"
                class="form-select form-control"
                aria-label="Tipo"
                placeholder="Elegir"
              >
                <option value="clear">Normal</option>
                <option value="box-blue">Relleno Azul</option>
              </select>
            </div>
            <div class="form-group col-lg-4">
              Orden: <input type="number" class="form-control" v-model="slides[selIndex].order" />
            </div>
            <div class="form-group col-lg-6">
              Texto link: <input type="text" class="form-control" v-model="slides[selIndex].name_link" />
            </div>
            <div class="form-group col-lg-6">
              Enlace: <input type="text" class="form-control" v-model="slides[selIndex].link" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <button class="btn btn-outline-light rounded-pill" @click="openModal">
        <i class="fal fa-plus"></i> Nuevo Slider
      </button> -->
    <button class="btn btn-outline-success rounded-pill" @click="saveSliders()">
      <i class="fal" :class="loading.upload ? 'fa-circle-notch fa-spin' : 'fa-save'"></i> Guardar
    </button>
    <button class="btn btn-outline-light rounded-pill ms-2" @click="onPickFile">
      <i class="fal" :class="loading.upload ? 'fa-circle-notch fa-spin' : 'fa-upload'"></i> Nuevo banner
    </button>
    <input
      type="file"
      style="display: none"
      ref="fileInput"
      accept="image/jpeg, image/png"
      @change="onFilePicked"
    />
    <button class="btn btn-outline-light rounded-pill ms-2" @click="openModal">
      <i class="fal fa-plus"></i> Seleccionar banner
    </button>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
      <div class="text-center">
        <div class="mb-2"><b>Seleccionar Banner</b></div>
        <div class="d-flex flex-wrap">
          <img
            class="galery-image-item"
            :src="photo.PathUrl"
            alt="image"
            v-for="(photo, indexPhoto) in photos.data"
            :key="photo.id"
            @click="selPhoto(photo, indexPhoto)"
          />
        </div>
        <Pagination :data="photos" @pagination-change-page="getPhotos" />
        <div class="d-flex justify-content-center mt-3">
          <button class="btn btn-light rounded-pill" @click="closeModal">Cancelar</button>
          <!-- <button class="btn btn-primary rounded-pill ms-2">Confirmar</button> -->
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import LaravelVuePagination from 'laravel-vue-pagination'
export default {
  name: 'SliderEdit',
  components: {
    Pagination: LaravelVuePagination,
  },
  data() {
    return {
      showModal: false,
      imageUrl: null,
      image: null,
      selIndex: null,
      slides: [],
      photos: [],
      loading: {
        slides: false,
        upload: false,
        photos: false,
      },
    }
  },
  mounted() {
    this.getSlides()
    this.getPhotos()
  },
  methods: {
    eliminarBanner(index) {
      this.closeModal()
      this.selIndex = null
      this.slides.splice(index, 1)
    },
    selPhoto(photo, index) {
      this.addSlide(photo)
      this.closeModal()
    },
    selectSlide(index) {
      if (index == this.selIndex) {
        return (this.selIndex = null)
      }
      this.selIndex = index
    },
    closeSelectSlide() {
      this.selIndex = null
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      let filename = files[0].name
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
      this.uploadImage()
    },
    getPhotos(page = 1) {
      const self = this
      self.loading.photos = true
      axios
        .get('/admin/photos?type=slide', {
          params: {
            page: page,
          },
        })
        .then((res) => {
          if (res.data.success) {
            self.photos = res.data.data
          }
        })
        .finally(() => {
          self.loading.photos = false
        })
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    getSlides() {
      const self = this
      self.loading.slides = true
      axios
        .get('/admin/slides')
        .then((res) => {
          if (res.data.success) {
            self.slides = res.data.data
          }
        })
        .finally(() => {
          self.loading.slides = false
        })
    },
    saveSliders() {
      const self = this
      self.loading.upload = true
      axios
        .post('/admin/slides', {
          slides: self.slides,
        })
        .then((res) => {
          if (res.data.success) {
            self.slides = res.data.data
          }
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          self.loading.upload = false
        })
    },
    addSlide(photo) {
      this.slides.push({
        id: null,
        title: null,
        en_title: null,
        photo_id: photo.id,
        PathUrl: photo.PathUrl,
        order: null,
        type: null,
        name_link: null,
        link: null,
      })
    },
    uploadImage() {
      const self = this
      const formData = new FormData()
      self.loading.upload = true
      formData.append('image', this.image)
      formData.append('type', 'slide')
      axios
        .post('/admin/photoUpload', formData)
        .then((res) => {
          console.log(res.data.data.PathUrl)
          self.addSlide(res.data.data)
        })
        .catch((err) => {
          console.error('Error:', err)
        })
        .finally(() => {
          self.loading.upload = false
        })
    },
  },
}
</script>
